<app-header [label]="page_name | plural"></app-header>
<app-ag-grid-list [list]="items" [colDefs]="columns" [itemName]="page_name" (fetch_new_list)="get_list($event)" (bulkDelete)="bulk_delete($event)" [getRowStyle]="getRowStyle">
  <div toolbar class="flex bg-white gap-4 items-center justify-between p-4 border-b border-gray-300">
    <div class="flex items-center gap-4">
      <app-select-input label="University" class="w-56" [options]="ds.dropdown_list?.university_list" (valueChange)="onFilterChange($event, 'university_id')"></app-select-input>
      <app-select-input label="Batch" class="w-56" [options]="ds.dropdown_list?.academic_list" (valueChange)="onFilterChange($event, 'academic_year_id')"></app-select-input>
    </div>
    <div class="flex items-center gap-4">
      <app-search-input #searchbar placeholder="Search Email / Unique ID..."></app-search-input>
      <app-button color="bg-white border-primary text-primary" icon="bx bx-download" (click)="items.count > 0 ? fs.bulk_download(us,'get_list', bulk_columns_download,'student',params) : null"></app-button>
      <app-dropdown-upload-button [page_name]="page_name" (bulkUpload)="bulk_modal.open()" (singleUpload)="open_form_modal()"> </app-dropdown-upload-button>
    </div>
  </div>
</app-ag-grid-list>
<app-confirmation-popup #confirmation_delete_modal label="Delete {{page_name}}?" [delete_icon]="true" cancelText="No" confirmColor="bg-[#FA2912] text-[#FFFFFF]" confirmText="Yes" [is_mandatory]="true" (confirm_modal_clicked)="disable_country()" (close_modal_clicked)="confirmation_delete_modal.close()">
  Are you sure you want to Delete this record?.
</app-confirmation-popup>
<app-confirmation-popup #confirmation_disabled_modal [enable_icon]="selected_ids.is_active == true ? false : true" confirmColor="bg-[#FA2912] text-[#FFFFFF]" [is_mandatory]="true" (confirm_modal_clicked)="update_country(selected_ids?.is_active)" (close_modal_clicked)="confirmation_delete_modal.close()">
  Are you sure you want to {{selected_ids?.is_active == true ? "Disable" :"Enable"}}
</app-confirmation-popup>
<app-modal #bulk_modal label="Bulk Upload {{page_name | plural}}" sub_label="Add {{ page_name }} in Bulk" (close_modal_clicked)="close_bulk_modal()">
  <app-bulk-upload [title]="page_name" [cancel]="bulk_modal" [accepted_type]="['.csv']" [max_file_sizeMB]="5" [bulk_columns]="bulk_columns" [extra_data]="bulk_form.value" [disabled]="!bulk_form.valid" (submit)="bulk_upload($event.data,$event.spinner)">
    <div class="flex flex-col gap-4" [formGroup]="bulk_form">
      <app-select-input label="University" class="w-full" [is_required]="true" formControlName="university_id" [options]="ds.dropdown_list?.university_list" (valueChange)="onBulkUniversityChange($event)"></app-select-input>
      <app-select-input label="Batch" class="w-full" [is_required]="true" formControlName="academic_year_id" [options]="filteredBulkAcademicYears"></app-select-input>
    </div>
  </app-bulk-upload>
</app-modal>
<!-- {{selected_ids | json}} -->
<app-modal #view_modal [label]="'View '+ page_name" width="md" (close_modal_clicked)="view_modal.close()">
  <!-- <div *ngIf="params.user_type === 'staff'" class="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Role</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.Role?.name || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Name</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.name || '—' }}</p>
    </div>
     <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Contact Details</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.contact || '—' }} {{ selected_ids?.email || '—' }}</p>
    </div>
      <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Exam</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.Exam?.name || '—' }}</p>
    </div>
  </div> -->
  <div class="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
    <!-- <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Role No</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.roll_number || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Date of Birth</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.birth_date || '—' }}</p>
    </div> -->
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">University</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.University?.name || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Batch</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.AcademicYear?.name || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Unique ID</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.registration_number || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Name</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.name || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">User Details</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.contact || '—' }} {{ selected_ids?.email || '—' }}</p>
    </div>
    <!-- <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Exam</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.user?.Exam?.name || '—' }}</p>
    </div> -->
  </div>
</app-modal>